interface Organization {
    id: number
    name: string
    slug: string
}

interface ImportSettingsProps {
    importMode: string
    organizationId: string
    organizations: Organization[]
    onImportModeChange: (mode: string) => void
    onOrganizationIdChange: (id: string) => void
}

export default function ImportSettings({
    importMode,
    organizationId,
    organizations,
    onImportModeChange,
    onOrganizationIdChange
}: ImportSettingsProps) {
    return (
        <div className="bg-white shadow sm:rounded-lg p-6">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Import Settings</h3>

            <div className="space-y-4">
                <div>
                    <label className="text-base font-medium text-gray-900">Import Mode</label>
                    <p className="text-sm text-gray-500">Choose how to handle the organization data</p>
                    <fieldset className="mt-4">
                        <div className="space-y-4">
                            <div className="flex items-center">
                                <input
                                    id="create_new"
                                    name="import_mode"
                                    type="radio"
                                    value="create_new"
                                    checked={importMode === 'create_new'}
                                    onChange={(e) => onImportModeChange(e.target.value)}
                                    className="h-4 w-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                                />
                                <label htmlFor="create_new" className="ml-3">
                                    <span className="block text-sm font-medium text-gray-700">Create New Organization</span>
                                    <span className="block text-sm text-gray-500">Create a completely new organization with all data</span>
                                </label>
                            </div>

                            <div className="flex items-center">
                                <input
                                    id="replace"
                                    name="import_mode"
                                    type="radio"
                                    value="replace"
                                    checked={importMode === 'replace'}
                                    onChange={(e) => onImportModeChange(e.target.value)}
                                    className="h-4 w-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                                />
                                <label htmlFor="replace" className="ml-3">
                                    <span className="block text-sm font-medium text-gray-700">Replace Organization Data</span>
                                    <span className="block text-sm text-gray-500">Wipe existing data and replace with uploaded data</span>
                                </label>
                            </div>

                            <div className="flex items-center">
                                <input
                                    id="append"
                                    name="import_mode"
                                    type="radio"
                                    value="append"
                                    checked={importMode === 'append'}
                                    onChange={(e) => onImportModeChange(e.target.value)}
                                    className="h-4 w-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                                />
                                <label htmlFor="append" className="ml-3">
                                    <span className="block text-sm font-medium text-gray-700">Append to Organization</span>
                                    <span className="block text-sm text-gray-500">Add new data to existing organization</span>
                                </label>
                            </div>
                        </div>
                    </fieldset>
                </div>

                {importMode !== 'create_new' && (
                    <div>
                        <label htmlFor="organization" className="block text-sm font-medium text-gray-700">
                            Select Organization
                        </label>
                        <select
                            id="organization"
                            value={organizationId}
                            onChange={(e) => onOrganizationIdChange(e.target.value)}
                            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                            required={importMode !== 'create_new'}
                        >
                            <option value="">Select an organization...</option>
                            {organizations.map((org) => (
                                <option key={org.id} value={org.id}>
                                    {org.name} ({org.slug})
                                </option>
                            ))}
                        </select>
                    </div>
                )}
            </div>
        </div>
    )
}